import { useMutation } from '@tanstack/react-query';
import { showSuccess, showError } from './toast';
import api from '../Services/api';
import { queryClient } from './queryClient';

export const useUpdateData = (
  queryKeyToInvalidate: any[],
  successMessage = 'Atualizado com sucesso!'
) => {
  return useMutation({
    mutationFn: async ({
      endpoint,
      id,
      payload,
    }: {
      endpoint: string;
      id: string | number;
      payload: any;
    }) => {
      const { data } = await api.put(`${endpoint}/${id}`, payload);
      return data;
    },
    onSuccess: () => {
      // ✅ Invalida a query específica
      if (queryKeyToInvalidate && queryKeyToInvalidate.length > 0) {
        queryClient.invalidateQueries({
          queryKey: queryKeyToInvalidate,
          exact: false,
        });
      }
   },
    onError: (error: any) => {
      showError(
        error?.response?.data?.message || error?.message || 'Erro ao atualizar.'
      );
    },
  });
};